import NavLinkButton from 'common/components/NavLinkButton';
import React from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

export default function UserPageOutlet() {
  const params = useParams();
  const userId = params.id || '';
  const location = useLocation();
  const state = location.state;
  console.log(state);
  return (
      <section className='user-section'>
        <h2 className='new-h2 add-user-title'>Картка клієнта</h2>
        <div className='add-user-nav-line'>
          <div className='add-user-nav-wrapper'>
            <NavLinkButton replace state={state} to={{ pathname: '' }} end>Загальна інформація</NavLinkButton>
            <NavLinkButton replace state={state} to={{ pathname: 'finances' }}>Фінанси</NavLinkButton>
            <NavLinkButton replace state={state} to={{ pathname: 'statistics' }}>Статистика</NavLinkButton>
          </div>
        </div>
        <Outlet context={{ userId }} />
      </section>
  );
}